/** 입력·선택 컨트롤의 공통 외형. 프로젝트 전체 폼을 바꿀 때 이 기준부터 수정한다. */
export const fieldStyles = {
  control:
    'w-full min-w-0 text-c15 text-foreground outline-none transition-[color,border-color] duration-200 placeholder:text-description disabled:cursor-not-allowed disabled:opacity-50',
  /**
   * 입력칸 면 — 한 줄 · 여러 줄 · 고르기 · 메시지 입력이 모두 이 한 값을 쓴다(색이 칸마다 달라지지 않게).
   * 애플 다크의 채운 칸: #2c2c2e, 테두리 없음, 호버로 색을 바꾸지 않고 포커스 때만 코랄 테두리
   */
  surface:
    'rounded-field border border-transparent bg-surface-raised focus-visible:border-point focus-within:border-point aria-invalid:border-error',
  /** 한 줄 입력 · 고르기 — 면 + 높이 44(컴팩트) */
  outline:
    'h-11 rounded-field border border-transparent bg-surface-raised px-4 focus-visible:border-point aria-invalid:border-error aria-invalid:focus-visible:border-error',
  label: 'mb-2 block text-c14 font-medium text-foreground over10:text-c15',
  error: 'mt-2 text-c12 leading-5 text-error',
  helper: 'mt-2 text-c13 leading-5 text-description',
} as const
